import { supabase } from './supabase';
import { toCamel } from '../utils/helpers';

export async function trainerAddBodyRecord({ memberId, date, weight, bodyFat, muscleMass, notes }) {
  const { data, error } = await supabase.rpc('trainer_add_body_record', {
    p_member_id:   memberId,
    p_date:        date,
    p_weight:      weight || null,
    p_body_fat:    bodyFat || null,
    p_muscle_mass: muscleMass || null,
    p_notes:       notes || null,
  });
  return { id: data, error };
}

export async function getMemberBodyRecords(memberId) {
  const { data, error } = await supabase.rpc('get_member_body_records', { p_member_id: memberId });
  if (error) { console.error('[getMemberBodyRecords]', error); return []; }
  return (data || []).map(toCamel);
}

export async function getMyBodyRecords() {
  const { data, error } = await supabase.rpc('get_my_body_records');
  if (error) { console.error('[getMyBodyRecords]', error); return []; }
  return (data || []).map(toCamel);
}

export async function deleteBodyRecord(id) {
  const { error } = await supabase.from('body_records').delete().eq('id', id);
  return { error };
}
